var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"road-content",staticStyle:{"width":"1200px","margin":"0 auto","text-align":"center","min-height":"500px"}},_vm._l((_vm.roadDetail),function(road){return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(road.content)}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e01d3ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RoadShowDetail.vue
// module id = null
// module chunks = 